import { cn } from "utils/helpers";

type SupplierListSuffixProps = {
	isCompanyApproved: boolean;
};

export const SupplierListSuffix = ({
	isCompanyApproved,
}: SupplierListSuffixProps) => (
	<div
		className={cn(
			"rounded-lg px-2 py-1 text-xs !font-medium text-white",
			isCompanyApproved
				? "bg-royal-blue text-white"
				: "bg-ring-blue-primary text-secondary-700"
		)}
	>
		{isCompanyApproved ? "Panel" : "My Supplier"}
	</div>
);
